import h5request from "../h5-network/request.js";

export const getActivityShareInfo = function (data) {
  return h5request({
    isNeedFullScreenLoading: true,
    url: "activityShare/getActivityShareInfo",
    data
  });
};
export const addRetransmissionTimes = function (data) {
  return h5request({
    isNeedFullScreenLoading: true,
    url: "activityTransmit/addRetransmissionTimes",
    method: "PUT",
    data
  });
};
///activityH5Info/getActivityH5ShareInfo
export const getActivityH5ShareInfo = function (data) {
  return h5request({
    isNeedFullScreenLoading: true,
    url: "activityH5Info/getActivityH5ShareInfo",
    method: "GET",
    data
  });
};
///activityH5Info/getEmployeeInfo
export const getEmployeeInfo = function (data) {
  return h5request({
    isNeedFullScreenLoading: true,
    url: "activityH5Info/getEmployeeInfo",
    method: "GET",
    data
  });
};
export const getActivityConfirmInfo = function (params) {
  return h5request({
    url: "materialConfirm/getActivityConfirmInfo",
    method: "GET",
    data: params,
  });
};


export const saveConsumerTransmitRecord = function (params) {
  return h5request({
    url: "activityTransmit/saveConsumerTransmitRecord",
    method: "POST",
    data: params,
  });
};
//保存或者取消点赞接口
export const saveOrCancelLikes = function (params) {
  return h5request({
    url: "activityLikes/saveOrCancelLikes",
    method: "POST",
    data: params,
  });
};
// 查看此h5活动全部点赞量和该用户是否对此活动进行点赞
export const getTotalLikes = function (params) {
  return h5request({
    url: "activityLikes/getTotalLikes",
    method: "GET",
    data: params,
  });
};
export const longToShort = function (params) {
  return h5request({
    url: "activityTransmit/longToShortLink",
    method: "POST",
    data: params
  });
};